<script setup lang="ts">

const localePath = useLocalePath();
const { t } = useI18n();

</script>

<template>
  <footer>
    <section id="testimonials">
      <h2>
        {{ t('testimonials.titlePrefix') }}<span class="accent">{{ t('testimonials.titleHighlight') }}</span>{{ t('testimonials.titleSuffix') }}
      </h2>
      <p class="testimonials-subtitle">{{ t('testimonials.subtitle') }}</p>
      <p class="testimonials-sources">{{ t('testimonials.sourcesSubtitle') }}</p>
      <ul id="rating">
        <li><img src="/images/star.png" alt="Star icon" width="37" height="35"/></li>
        <li><img src="/images/star.png" alt="Star icon" width="37" height="35"/></li>
        <li><img src="/images/star.png" alt="Star icon" width="37" height="35"/></li>
        <li><img src="/images/star.png" alt="Star icon" width="37" height="35"/></li>
        <li><img src="/images/star.png" alt="Star icon" width="37" height="35"/></li>
      </ul>
      <testimonials-carousel compact class="footer-testimonials" />
      <div class="quality-badge">
        <div id="lcqualitybadge"></div>
      </div>
    </section>
    <nav class="montserrat bold">
      <div>
        <h2>{{ t('footer.aboutCompany') }}</h2>
        <ul>
          <li><NuxtLink :to="localePath('/contacts')">{{ t('footer.contacts') }}</NuxtLink></li>
          <li><NuxtLink :to="localePath('/brands')">{{ t('footer.brands') }}</NuxtLink></li>
        </ul>
      </div>
      <div>
        <h2>{{ t('footer.legal') }}</h2>
        <ul>
          <li>
            <NuxtLink :to="localePath('/privacy')">{{ t('footer.privacy') }}</NuxtLink>
          </li>
          <li><NuxtLink :to="localePath('/terms')">{{ t('footer.terms') }}</NuxtLink></li>
        </ul>
      </div>
      <div>
        <h2>{{ t('footer.community') }}</h2>
        <ul>
          <li><NuxtLink :to="localePath('/blog')">{{ t('blog.link') }}</NuxtLink></li>
          <li><NuxtLink :to="localePath('/nature')">{{ t('footer.nature') }}</NuxtLink></li>
          <li><a href="https://my1private.com" target="_blank" rel="noopener">Private Water Immune</a></li>
        </ul>
      </div>
    </nav>
  </footer>
</template>

<style scoped>

footer {
  position: relative;

  #testimonials {
    background-image: url("/images/background/waves-footer-sm.png");
    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    padding-bottom: 2rem;

    h2 {
      font-size: 28px;
      text-align: center;
      font-weight: 800;
    }

    .testimonials-subtitle {
      margin-top: 2.5rem;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
    }

    .testimonials-sources {
      margin-top: 0.25rem;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      color: var(--dark-gray, #555);
    }

    #rating {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin-top: .5rem;

      img {
        width: 38px;
      }

    }

    :deep(.footer-testimonials) {
      margin-top: 1.5rem;
      padding-top: 0;
      padding-bottom: 0;
    }

    .quality-badge {
      display: flex;
      justify-content: center;
      margin-top: 2rem;
    }
  }

  @media (min-width: 769px) {
    #testimonials {
      background-image: url("/images/background/footer-waves-xl.png");

      h2 {
        margin: auto;
      }
    }
  }

  nav {
    display: flex;
    align-items: flex-start;

    img {
      height: 100px;
    }

    padding: 2rem 2rem 2rem 120px;
    background-color: var(--lightest-blue);
    justify-content: space-between;

    h2 {
      font-weight: bold;
    }

    ul {
      font-weight: 400;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    li {
      font-size: 14px;
    }

    /* WCAG 2.2 target size: at least 24x24px, with enough gap that the
       24px target circles of adjacent links never overlap. */
    li a {
      display: inline-flex;
      align-items: center;
      min-height: 24px;
      padding: 2px 0;
      cursor: pointer;
    }

    li a:hover {
      text-decoration: underline;
    }

    @media (width <= 768px) {
      img {
        height: 50px;
        margin-right: .5rem;
      }

      h2 {
        font-size: 14px;
      }

      li {
        font-size: 12px;
      }

      flex-direction: column;
      gap: 10px;
      padding: 2rem .5rem .5rem 120px;
    }
  }

  nav::before {
    position: absolute;
    left: 10px;
    content: '';
    width: 90px;
    height: 81px;
    background-image: url('/images/logo/logo-footer.avif');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }


}

</style>
